import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconWarningSignFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M31.703 26.845 17.9 2.965c-.84-1.48-2.96-1.48-3.8 0L.297 26.845c-.84 1.48.2 3.3 1.9 3.3h27.606c1.7 0 2.74-1.82 1.9-3.3M15 11.545c0-.54.44-1 1-1s1 .46 1 1v9.12c0 .54-.44 1-1 1s-1-.46-1-1zm1 14.64c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3 1.3.58 1.3 1.3-.58 1.3-1.3 1.3" clipRule="evenodd" /></svg>;
export default SvgIconWarningSignFilled;